import { Image } from '@accedo/ctv-image';
import { FunctionalComponent } from 'preact';

interface LazyImageProps {
  url?: string;
  fallbackUrl?: string;
  width?: number;
  height?: number;
  className?: string;
  onLoad?: (element?: HTMLImageElement) => void;
  isShowing?: boolean;
}

const LazyImage: FunctionalComponent<LazyImageProps> = ({
  className,
  height,
  width,
  isShowing,
  ...rest
}) =>
  isShowing ? (
    <Image height={height} width={width} className={className} {...rest} />
  ) : (
    <div className={className} style={{ height, width }} />
  );

export default LazyImage;
